<head>

</head>
<body>
    <div class="intro">
        <div class="container">
            <!-- Title -->
            <div style="text-align: center;">
            <h2>
                <span
                    style="position:relative;top:20px;color:white"
                    class="pacificofont"><b><i>{{customerName}} Transactions</i></b></span>
                <br><br><br><br>
            </h2>
        </div>
            <!-- Title -->


            <!-- Search Bar -->
            <div class="form-group">
                <input id="searchBar" type="text" class="form-control"
                    [(ngModel)]="text"
                    placeholder="Search">
            </div>
            <div *ngIf="text === '';then content else other_content"></div>
            <!-- Search Bar -->


            <!-- Create Excel Button -->
            <div *ngIf="show_createExcel === false">

                <button
                    style="position:absolute;top:100px;margin-left:970px;"
                    type="button"
                    class="btn
                    btn-success" (click)="createTransactionCSV()"><i class="fa
                        fa-file-excel-o"></i> Create Excel</button>

            </div>


            <div *ngIf="show_createExcel === true">

                <button style="position:absolute;top:100px;margin-left:970px;" type="button"
                    class="btn btn-success"
                    disabled>
                    <span class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"></span>
                    Creating...</button>

            </div>
            <!-- Create Excel Button -->

            <!-- Create Pdf Button -->
            <div *ngIf="show_createPdf === false">

                <button style="position:absolute;top:100px;margin-left:840px;" type="button"
                    class="btn
                    btn-danger" (click)="createTransactionPdf()"><i class="fa
                        fa-file-excel-o"></i> Create Pdf</button>

            </div>


            <div *ngIf="show_createPdf === true">

                <button style="position:absolute;top:100px;margin-left:840px;" type="button"
                    class="btn btn-danger"
                    disabled>
                    <span class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"></span>
                    Creating...</button>

            </div>
            <!-- Create Pdf Button -->


            <!-- Transaction List Pagination Table -->
            <ng-template #content>
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th class="table-dark" *ngFor="let head of
                                headElements"
                                scope="col">{{head}} </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="table-light" *ngFor="let transaction of
                            transactionList |
                            paginate : {id :
                            'listing_pagination',
                            itemsPerPage : 10,
                            currentPage : page,
                            totalItems : totalRecords
                            }; let i=index">
                            <td>{{ (page - 1) * 10 + i +1 }}</td>
                            <td>{{transaction.transactionDate}} ( {{transaction.transactionTime}})</td>
                            <td>{{transaction.transactionName}}</td>
                            <td>{{transaction.transactionCredit}}</td>
                            <td>{{transaction.transactionDebit}}</td>
                            <td>{{transaction.transactionPending}}</td>
                        </tr>

                    </tbody>
                    <tbody>
                    <tr class="table-info">
                        <td></td>
                        <td></td>
                        <td>Total </td>
                        <td>{{totalCredit}}</td>
                        <td>{{totalDebit}}</td>
                        <td>{{totalPending}}</td>
                    </tr>
                </tbody>
                </table>

                <div>
                    <pagination-controls style="color:white;"
                        id="listing_pagination"
                        (pageChange)="page=
                        $event"></pagination-controls>
                </div>

            </ng-template>
            <!-- Transaction List Pagination Table -->


            <!-- Transaction List Search Table -->
            <ng-template #other_content>
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th class="table-dark" *ngFor="let head of
                                headElements"
                                scope="col">{{head}} </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="table-light" *ngFor="let transaction of
                            transactionList |
                            filter:text;let i=index">
                            <td>{{ (page - 1) * 10 + i +1 }}</td>
                            <td>{{transaction.transactionDate}} ( {{transaction.transactionTime}})</td>
                            <td>{{transaction.transactionName}}</td>
                            <td>{{transaction.transactionCredit}}</td>
                            <td>{{transaction.transactionDebit}}</td>
                            <td>{{transaction.transactionPending}}</td>
                        </tr>

                    </tbody>
                    <tbody>
                        <tr class="table-info">
                            <td></td>
                            <td></td>
                            <td>Total </td>
                            <td>{{totalCredit}}</td>
                            <td>{{totalDebit}}</td>
                            <td>{{totalPending}}</td>
                        </tr>
                    </tbody>
                </table>



            </ng-template>
            <!-- Transaction List Search Table -->
        </div>
    </div>
    <!-- Transaction Table -->
</body>